"use client";

import { useEffect } from "react";
import { installDeviceHeaderFetch } from "@/app/_module/utils/device-header-fetch";

/**
 * Installs the `X-Device-Id` fetch wrapper for the whole app.
 *
 * Mounted in the ROOT layout rather than the authenticated one: sign-in itself
 * runs on public routes and needs the header too, and this way a page added
 * later cannot forget it. See device-header-fetch.ts for why the wrapper
 * exists at all.
 */
// Installed at MODULE scope, not only in the effect: effects run after the first
// render, and components that fetch in their own mount effect can beat a parent's
// effect to it. Importing this module is enough to patch fetch, so the wrapper is
// in place before any component code runs. The effect below is a safety net for
// remounts and fast-refresh; the install itself is idempotent.
if (typeof window !== "undefined") {
  installDeviceHeaderFetch();
}

export function DeviceHeaderFetchInstaller() {
  useEffect(() => {
    installDeviceHeaderFetch();
  }, []);

  return null;
}
